import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/Login.vue'
import Home from '@/views/Home.vue'
import MealControl from '@/views/mealControl/index.vue'
import StudentTrays from '@/views/mealControl/StudentTrays'
import StudentRegistration from '@/views/StudentRegistration/'
import StudentRegistrationTabs from '@/views/StudentRegistration/Tabs'
import FormStudentIdentification from '@/views/StudentRegistration/Forms/FormStudentIdentification'
import FormFamilyData from '@/views/StudentRegistration/Forms/FormFamilyData'
import FormStudentHealth from '@/views/StudentRegistration/Forms/FormStudentHealth'
import FormRoutine from '@/views/StudentRegistration/Forms/FormRoutine'
import FormImageRight from '@/views/StudentRegistration/Forms/FormImageRight'
import FormResponsibleStudents from '@/views/StudentRegistration/Forms/FormResponsibleStudents'
import FormStudentSchoolRoutine from '@/views/StudentRegistration/Forms/FormStudentSchoolRoutine'
import FormStudentDocument from '@/views/StudentRegistration/Forms/FormStudentDocument'
import NewPassword from '@/views/NewPassword'
import AccountRecovery from '@/views/AccountRecovery'
import PageNotFound from '@/views/PageNotFound'
import ResetPassword from '@/views/ResetPassword'

import { privateRoute, loginRoute, requiresNoUserRoute } from './AuthGuards'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '*',
      component: PageNotFound
    },
    loginRoute({
      path: '/login',
      name: 'login',
      component: Login
    }),
    privateRoute({
      path: '/',
      name: 'home',
      component: Home
    }),
    privateRoute({
      path: '/refeicoes/estudantes/',
      name: 'meal_control',
      component: MealControl
    }),
    privateRoute({
      path: '/refeicoes/estudantes/:id/bandejas',
      name: 'meal_control_trays',
      component: StudentTrays
    }),
    privateRoute({
      path: '/registro/estudantes/',
      name: 'student_register',
      component: StudentRegistration
    }),
    privateRoute({
      path: '/registro/estudantes/:id/',
      name: 'student_register_tabs',
      component: StudentRegistrationTabs,
      children: [
        privateRoute({
          path: 'identificacao',
          component: FormStudentIdentification
        }),
        privateRoute({
          path: 'dados_familiares',
          component: FormFamilyData
        }),
        privateRoute({
          path: 'saude',
          component: FormStudentHealth
        }),
        privateRoute({
          path: 'rotina',
          component: FormRoutine
        }),
        privateRoute({
          path: 'direito_de_imagem',
          component: FormImageRight
        }),
        privateRoute({
          path: 'autorizacao_de_retirada',
          component: FormResponsibleStudents
        }),
        privateRoute({
          path: 'documentacao',
          component: FormStudentDocument
        }),
        privateRoute({
          path: 'rotina_escolar',
          component: FormStudentSchoolRoutine
        })
      ]
    }),
    requiresNoUserRoute({
      path: '/new_password',
      component: NewPassword,
      meta: {
        message: 'Para realizar o processo de criação de uma nova senha, faça logout primeiro.'
      }
    }),
    requiresNoUserRoute({
      path: '/account_recovery',
      component: AccountRecovery,
      meta: {
        message: 'Para recuperar sua conta, faça logout primeiro.'
      }
    }),
    requiresNoUserRoute({
      path: '/reset_password',
      component: ResetPassword,
      meta: {
        message: 'Para criar uma nova senha, faça logout primeiro.'
      }
    })
  ]
})

export default router
